module.exports = __webpack_public_path__ + "static/media/hometown-3-shot-4.356b1952.webp";